import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { printTime } from '../../lib/utils';
import DialogTrigger from '../dialog-trigger';
import QuestionIcon from './assets/questionMarkCircle.svg?react';
import GeneralTooltip from '../general-tooltip';

const Text = styled.p`
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    margin: 0;
`;

const BoldText = styled(Text)`
    font-weight: 600;
`;

const ItalicText = styled(Text)`
    font-size: 12px;
    font-style: italic;
    letter-spacing: 0.32px;
    line-height: 16px;
`;

export const WarningText = styled(BoldText)`
    color: var(--red700);
`;

export const InitialTime = styled(ItalicText)`
    margin-bottom: 24px;
`;

const TimeRemainingWarning = styled.div`
    display: flex;
    align-items: center;
    margin-top: 24px;

    & > *:not(:last-child) {
        margin-right: 4px;
    }

    & svg {
        width: 18px;
        height: 18px;
        fill: ${(props) => props.theme.colors['myzanichelli-blue-main']};
    }
`;

const TooltipContent = styled.div`
    width: 240px;
`;

const AssignmentTimeWarning = ({ time, remainingTime }) => {
    return (
        <>
            <TimeRemainingWarning>
                <WarningText>{`Attenzione! Mancano ${printTime(remainingTime)} minuti alla consegna`}</WarningText>
                <DialogTrigger>
                    <QuestionIcon />
                    <GeneralTooltip position="bottom">
                        <TooltipContent>{`Quando inizi la prova troppo vicino all'orario di consegna, il tempo a tua disposizione si riduce.`}</TooltipContent>
                    </GeneralTooltip>
                </DialogTrigger>
            </TimeRemainingWarning>
            <InitialTime>{`Tempo iniziale: ${printTime(time)}`}</InitialTime>
        </>
    );
};

AssignmentTimeWarning.propTypes = {
    remainingTime: PropTypes.number,
    time: PropTypes.number,
};

export default AssignmentTimeWarning;
